import { type CardFieldAttributes } from './generated/CardFieldAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { CardFieldTypesEnum } from '../Enums';
import { HasCardLayoutHierarchy } from './concerns/HasCardLayoutHierarchy';
import { JsonQuerySerialization } from './concerns/JsonQuerySerialization';
import type CustomField from 'components/CardLayoutEditor/models/CustomField';
import type Field from 'components/CardLayoutEditor/models/Field';

interface CardField extends CardFieldAttributes, HasCardLayoutHierarchy {
  field: CustomField | Field;
}

@model
@HasCardLayoutHierarchy
@JsonQuerySerialization
class CardField extends ApplicationModel {
  // Start auto-generated
  static typename: 'CardField' = 'CardField';
  get typename(): 'CardField' {
    return 'CardField';
  }

  static inputType = 'CardFieldAttributes';

  static fields = {
    id: attr({ writable: true, readable: true }),
    key: attr({ writable: true, readable: true }),
    type: attr({ writable: true, readable: true }),
    customFieldDefinition: attr.belongsTo({
      readable: true,
      typename: 'CustomFieldDefinition',
    }),
  };
  // End auto-generated

  initialize() {
    const { recordFields } = this.recordLayout;

    switch (this.type) {
      case CardFieldTypesEnum.CUSTOM_FIELD.value:
      case CardFieldTypesEnum.CUSTOM_OBJECT_LINK.value:
        this.field = recordFields.buildCustomField(this.customFieldDefinition);
        break;
      case CardFieldTypesEnum.CUSTOM_FIELD_SET.value:
        this.field = recordFields.buildCustomField(
          this.customFieldDefinition,
          this.key.split('_')[1]
        );
        break;

      case CardFieldTypesEnum.STANDARD_FIELD.value:
        this.field = recordFields.field(this.key);
        break;
    }
  }

  buildScope(query) {
    return this.field.buildScope(query);
  }

  /**
   * Compares another CardField to this, and returns whether they are equal or not.
   *
   * @param {CardField} otherField The CardField to compare.
   */
  isEqualTo(otherField) {
    return this.type === otherField.type && this.key === otherField.key;
  }
}

export default CardField;
